const state = {
    isLoggedIn: !!localStorage.getItem('token'),
}

const mutations = {
    toggleLogin(state) {
        state.isLoggedIn = true;
    },
    toggleLogout(state) {
        state.isLoggedIn = false;
    },
    set (state, [variable, value]) {
        state[variable] = value
    },
};

export default {
    namespaced: true,
    state,
    mutations
};
